import { SIGN_IN_ADMIN_URL } from '../constants/urls';
import api from './api';

export const loginAdminRequest = (user) => api({
  method: 'post',
  url: SIGN_IN_ADMIN_URL,
  data: { user },
}, { isEntityAttributes: true });
